import { FC } from 'react';

export const Mail24: FC = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.61728 5C4.24604 5 3 6.22761 3 7.97241V16.0276C3 17.7724 4.24604 19 5.61728 19H18.4787C19.8543 19 21.0741 17.7764 20.9966 16.0731C20.9959 16.0579 20.9955 16.0428 20.9955 16.0276V7.97241C20.9955 6.22761 19.7495 5 18.3783 5H5.61728ZM1 7.97241C1 5.30343 2.96932 3 5.61728 3H18.3783C21.0262 3 22.9955 5.30343 22.9955 7.97241V16.0061C23.1061 18.7062 21.1146 21 18.4787 21H5.61728C2.96932 21 1 18.6966 1 16.0276V7.97241Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.13 7.50701C5.40231 7.02652 6.01256 6.85775 6.49305 7.13005L11.1718 9.7816C11.7135 10.0729 12.2865 10.0729 12.8282 9.7816L17.507 7.13005C17.9874 6.85775 18.5977 7.02652 18.87 7.50701C19.1423 7.9875 18.9735 8.59775 18.4931 8.87006L13.8056 11.5265L13.7896 11.5354C12.6483 12.1549 11.3517 12.1549 10.2104 11.5354L10.1945 11.5265L5.50696 8.87006C5.02647 8.59775 4.8577 7.9875 5.13 7.50701Z"
      />
    </svg>
  );
};
